module.exports = __webpack_public_path__ + "static/media/notifications-icon.4f54c507.svg";